import "core-js/modules/es.array.push.js";
import { defineComponent, ref, reactive, onMounted, toRefs } from 'vue';
import { useRouter } from 'vue-router';
export default {
  name: "TransLogTabs",
  components: {},
  setup() {
    const router = useRouter(); // 路由跳转
    let data = {
      tabPosition: 'left'
    };
    const handleClick = tab => {
      if ("uploading" == tab.props.name) {
        router.push("/home/trans-log/uploading");
      } else if ("downloading" == tab.props.name) {
        router.push("/home/trans-log/downloading");
      } else if ("finished" == tab.props.name) {
        router.push("/home/trans-log/finished");
      }
    };
    return {
      ...toRefs(data),
      handleClick
    };
  }
};